import React, {Component} from 'react'
import { fetchFeatured } from './../services/ApiController'
import { Card, SlideshowMobile } from './'
import { FeaturedStyle } from './../styles'

export default class Featured extends Component {
  state = {
    featured: [],
    ready: false,
  }

  componentDidMount() {
    this.getFeatured()
  }

  getFeatured = () => {
    fetchFeatured().then((data) => {
        const nData = []
        let i = 0
        Object.keys(data).map((row, index) => {
          nData.push(data[row])
          i = index
          if (i === Object.keys(data).length - 1) this.setState({ featured: nData, ready: true })
        })
    }).catch((err) => {
      console.log('Something Wrong with Featured data', err)
    })
  }
  
  render() {
    const { home } = this.props
    const { featured, ready } = this.state
    return(
      <div className={`featured fluid ${FeaturedStyle(ready)}`}>
        <h2>Featured</h2>
        <SlideshowMobile isHome={home} ready={ready}>
          {
            featured && featured.map((feature, index) => (
              <Card {...feature} description='' key={index} label="discover"/>
            ))
          }
        </SlideshowMobile>
      </div>
    )
  }
}

// title, picture, type, path




// WEBPACK FOOTER //
// ./src/components/Featured.js